module.exports = __webpack_public_path__ + "src/assets/img/StdBath.350335b1.jpg";